"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.prefixes = exports.hosts = exports.config = exports.baseValues = void 0;
var _utils = require("@site/utils");
const baseValues = exports.baseValues = {
  auctionContinue: '/trpItemListing.aspx',
  contentApi: '/content/SERP/v1',
  crossSellGet: '/domainfind/v1/crosssell/all',
  exactGet: '/domainfind/v1/search/exact',
  exactMatchGet: '/domainfind/v1/search/exactMatch',
  divinerGet: '/domainfind/v1/diviner',
  afterMarketAuctionRecommend: '/v4/aftermarket/find/auction/recommend',
  basketGet: '/v1/pl/{privateLabelId}/cart',
  sapiCartPackages: '/v1/pl/{privateLabelId}/cart/packages',
  sapiCartDomains: '/v1/pl/{privateLabelId}/cart/domains',
  bundleGet: '/domainfind/v1/bundles',
  smartBundleGet: '/domainfind/v1/search/smartbundles',
  smartExactGet: '/domainfind/v1/search/smartexact',
  solutionImages: '/serpimg/img/solutionsimg/',
  spinsGet: '/domainfind/v1/search/spins',
  sslHelpUrl: '/help/ssl-certificates-1000006',
  support: '/v1/plid/1/contacts',
  deepIndustryGet: '/domainfind/v1/deepindustry',
  queryComplete: '/domainfind/autocomplete',
  uipApi: '/v1/users/insights/{endpoint}',
  getDomainSearchComponentBFFApi: '/domainsearch/getComponentData',
  merchRecommend: '/domainfind/v1/merchrecommend/domain',
  logoGeneration: '/v1/go-caas/logo',
  domainSuggestions: '/v1/customers/{customerId}/domainSuggestions',
  llcAvailCheck: '/v1/formations/name-availability',
  addToCartTrack: '/domainfind/v1/addtocart'
};
const prefixes = exports.prefixes = {
  find: 'https://',
  reseller: 'https://www.',
  sapi: 'https://salesproducts.api.',
  uip: 'https://uip.',
  genAi: 'https://mvci.api.',
  llcAvailCheck: 'https://api.'
};
const hosts = exports.hosts = {
  dev: {
    auction: 'auctions.dev-godaddy.com',
    find: 'dev-godaddy.com',
    reseller: 'dev-secureserver.net',
    solutionImages: 'entourage.dev.aws.godaddy.com',
    dccDomains: 'domains.dcc.api.dev-godaddy.com',
    llcAvailCheck: 'tailorbrands.com',
    findAftermarket: 'find.api.dev.aws.godaddy.com'
  },
  prod: {
    auction: 'auctions.godaddy.com',
    find: 'godaddy.com',
    reseller: 'secureserver.net',
    solutionImages: 'img6.wsimg.com',
    dccDomains: 'domainsapi.godaddy.com',
    llcAvailCheck: 'tailorbrands.com',
    findAftermarket: 'find.api.prod.aws.godaddy.com'
  },
  test: {
    auction: 'auctions.test-godaddy.com',
    find: 'test-godaddy.com',
    reseller: 'test-secureserver.net',
    solutionImages: 'entourage.test.aws.godaddy.com',
    dccDomains: 'domains.dcc.api.test-godaddy.com',
    llcAvailCheck: 'tailorbrands.com',
    findAftermarket: 'find.api.prod.aws.godaddy.com'
  }
};
const config = exports.config = {
  getSubDomainAndLanguage: (marketCookie = 'en-US') => {
    return _utils.Markets[marketCookie] || _utils.Markets['en-US'] || {
      subDomain: 'www',
      languagePath: null
    };
  },
  isValidEnv: env => {
    const envValues = ['prod', 'dev', 'test'];
    return envValues.includes(env);
  },
  isReseller: plid => {
    return !(plid === '1' || plid === 1);
  },
  getPaths: env => {
    const paths = {
      dev: baseValues,
      test: baseValues,
      prod: baseValues
    };
    return paths[env];
  },
  getPrefixes: (isReseller, subDomain = 'www') => {
    return isReseller ? prefixes.reseller : `${prefixes.find}${subDomain}.`;
  },
  getHosts: (env = 'prod', plid = 1, market = 'en-US', resellerBaseOverride) => {
    if (!hosts[env]) return;
    const {
      subDomain,
      languagePath
    } = config.getSubDomainAndLanguage(market);
    const isReseller = config.isReseller(plid);
    const prefix = config.getPrefixes(isReseller, subDomain);
    const host = isReseller ? resellerBaseOverride || hosts[env].reseller : hosts[env].find;
    return languagePath && !isReseller ? `${prefix}${host}/${languagePath}` : `${prefix}${host}`;
  },
  getSapiHost: (env = 'prod', plid = 1, resellerBaseOverride) => {
    if (!hosts[env]) return;
    const host = config.isReseller(plid) ? resellerBaseOverride || hosts[env].reseller : hosts[env].find;
    return `${prefixes.sapi}${host}`;
  },
  getGenAiHost: (env = 'prod', plid = 1, resellerBaseOverride) => {
    if (!hosts[env]) return;
    const host = config.isReseller(plid) ? resellerBaseOverride || hosts[env].reseller : hosts[env].find;
    return `${prefixes.genAi}${host}`;
  },
  getUipHost: (env = 'prod') => {
    if (!hosts[env]) return;
    const host = hosts[env].find;
    return `${prefixes.uip}${host}`;
  },
  getAuctionsHost: (env = 'prod', plid = 1, market = 'en-US') => {
    if (!hosts[env]) return;
    const {
      subDomain,
      languagePath
    } = config.getSubDomainAndLanguage(market);
    const isReseller = config.isReseller(plid);
    const prefix = config.getPrefixes(isReseller, subDomain);
    const host = hosts[env].auction;
    const paths = config.getPaths(env);
    return `${prefix}${host}${languagePath && !isReseller ? `/${languagePath}` : ''}${paths.auctionContinue}`;
  },
  getDccDomainsHost: (env = 'prod') => {
    if (!hosts[env]) return;
    const host = hosts[env].dccDomains;
    return `${prefixes.find}${host}`;
  },
  getLLCAvailCheckApiHost: (env = 'prod') => {
    if (!hosts[env]) return;
    const host = hosts[env].llcAvailCheck;
    return `${prefixes.llcAvailCheck}${host}`;
  },
  getFindAftermarketHost: (env = 'prod') => {
    if (!hosts[env]) return;
    const host = hosts[env].findAftermarket;
    return `${prefixes.find}${host}`;
  }
};